<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">W9 Request</div>
    </template>

    <Section>
      <template #header>
        <strong>What to expect</strong>
      </template>
      
      <div>
        In the next few screens, you will be asked to to complete a W-9.
        In the case that your rewards exceed the IRS reporting threshold, this
        will be used to report your earnings.  This information will not be
        shared with any partner. If you have any questions, please read the
        official <a href="https://www.irs.gov/forms-pubs/about-form-w-9">IRS guidelines.</a>
      </div>
    </Section>

    <Section>
      <template #header class="d-flex align-center">
        <div class="font-weight-bold mr-auto">Certification</div>
        <v-btn v-if="!cert_open" fab x-small color="primary" @click="cert_open=true">
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        <v-btn v-else fab x-small color="primary" @click="cert_open=false">
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </template>

      <div :style="cert_style">
        Under penalties of perjury, I certify that: 1. The number shown on this form
        is my correct taxpayer identification number (or I am waiting for a number
        to be issued to me); and 2. I am not subject to backup withholding because:
        (a) I am exempt from backup withholding, or (b) I have not been notified by
        the Internal Revenue Service (IRS) that I am subject to backup withholding as
        a result of a failure to report all interest or dividends, or (c) the IRS
        has notified me that I am no longer subject to backup withholding; and 3. I
        am a U.S. citizen or other U.S. person (defined below); and 4. The FATCA
        code(s) entered on this form (if any) indicating that I am exempt from FATCA
        reporting is correct.
      </div>
    </Section>

    <Section class="pt-0">
      <v-form ref="form" @submit.prevent="nextClick">
        <div class="d-flex align-center">
          <v-checkbox 
            v-model="certified"
            dense hide-details="auto"
            :rules='[is_certified]'
            label="I acknowlege that I have read and agree that the all information I have given is true."
          />
          
        </div>
        <div class="d-flex justify-center mt-3">
          <v-btn color="primary" type="submit">Continue</v-btn>
        </div>
      </v-form>
    </Section>
  </ContentPage>
</template>

<script>

import { ContentPage, Section } from '@/components/pages'

export default {
  name: 'AccountW9CertificationPage',

  components: { ContentPage, Section },

  data: () => ({
    certified: false,
    cert_open: false,
    
    is_certified: v => v || 'You must certify to continue'
  }),

  computed: {
    cert_style() {
      if (!this.cert_open) {
        return { 
          'font-size': '12px',
          'overflow-y': 'auto',
          'max-height': '135px'
        }
      } else {
        return { 'font-size': '12px' }
      }
    },
  },

  methods: {
    nextClick() {
      if (this.$refs.form.validate()) {
        this.$router.push({ name: 'account/w9/form' })
      }
    }
  }
}
</script>